<div class="root-container">
  <page-title text="Your Profile" bi_icon="bi-person-fill" />
  @if (!loading) {
    <div class="content">
    <div class="button-edit" (click)="editing = !editing"><i class="bi bi-pencil-square button-edit"></i> Edit</div>

    <div class="header">
      <div (click)="upload_modal.onShow()" class="profile-img">
        <i class="bi bi-x-lg remove-photo" [ngClass]="{ 'd-none': !user().image}" (click)="confirmRemovePhoto($event)"></i>
        <img [src]="user().image ?? 'assets/images/defaults/default_user.png'" alt="user profile">
        <span class="pen"><i class="bi bi-pen"></i></span>
      </div>
      <p class="name">{{ user().first_name }} {{ user().middle_name ?? '' }} {{ user().last_name }}</p>
      <p class="email">{{ user().email }}</p>
    </div>

    <div class="body">
      <div class="section-title">
        <span>Personal Information</span>
      </div>

      <personal-information [form]="personal_information_form" [editing]="editing" />

      <div class="section-title">
        <span>Location</span>
      </div>

      <user-location [form]="location_form" [data_regions]="data_regions()" [editing]="editing" />

      <div class="section-title">
        <span>Other Information</span>
      </div>

      <other-information [form]="other_information_form" />
    </div>

    @if(editing) {
      <div class="footer">
        <button-component text="Save" type="primary" (click)="save()" />
        <button-component text="Cancel" type="secondary" (click)="editing = !editing" />
      </div>
    }

    <profile-image-upload #upload_modal (onSubmit)="updateProfileImage($event)" />
  </div>
  }
  @else {
    <div class="text-center">
      <spinner />
    </div>
  }
</div>
